import { ORG_PRODUCTS_TAB_ES_ES } from "./products-tab";
import { ORG_PRODUCTS_CATEGORIES_ES_ES } from "./categories";
import { OrgProductsTranslations } from "#i18n/translations/pt-BR/org/products";

export const ORG_PRODUCTS_ES_ES: OrgProductsTranslations = {
	tabs: {
		productsTab: ORG_PRODUCTS_TAB_ES_ES,
		categories: ORG_PRODUCTS_CATEGORIES_ES_ES,
		generalStock: "Stock General",
	},
	functions: {
		modal: {
			sheet: {
				inventory: "inventario",
				columns: {
					id: "Id del producto",
					name: "Nombre",
					category: "Categoría",
					type: "Tipo de producto",
					hasAlcohol: "¿Contiene alcohol?",
					fiscalCode: "SKU",
					fiscalNcm: "Fiscal - NCM",
				},
			},
		},
	},
	emptyList: "Ningún producto encontrado",
};
